import type { AgencyModel } from '@models/types'

import { BULK_ACTION_SERVICE_PROVIDERS } from '@functions/integrationPlatform'

import IntegrationPlatform from './IntegrationPlatform'

interface IntegrationPlatformsProps {
  agency: AgencyModel,
}

const IntegrationPlatforms = (props: IntegrationPlatformsProps) => {
  const { agency } = props

  return (
    BULK_ACTION_SERVICE_PROVIDERS.map(
      serviceProvider => <IntegrationPlatform agency={agency} serviceProvider={serviceProvider} />,
    )
  )
}

export default IntegrationPlatforms
